export interface ProductCardPriceTypes {
  productPrice?: number | null;
  productPriceOriginal?: number | null;
  productMemberPrice?: number | null;
  productNumberOfBottles?: number | null;
}
import { useScreenLayout } from 'common-ui';
import type { ProductCardProps } from './ProductCard';
import { useTheme } from '@emotion/react';

export const getOverrideImage = (props: ProductCardProps) => {
  const { screen, isMobile } = useScreenLayout();
  const hasSmallImage = Boolean(props.productImageOverride?.fields?.smallDeviceImage?.fields?.file?.url);
  const isMobileWithScreen = screen && isMobile && hasSmallImage;
  const smallImageUrl = props.productImageOverride?.fields?.smallDeviceImage?.fields?.file?.url;
  const largeImageUrl = props.productImageOverride?.fields?.largeDeviceImage?.fields?.file?.url;

  if (isMobileWithScreen) {
    return smallImageUrl;
  }
  return largeImageUrl;
};

export const getProductCardStyle = (props: ProductCardProps) => {
  const theme = useTheme();
  const { productCardVariant } = props || {};
  const fullBleedBackground = productCardVariant === 'Full bleed background';
  const standardProductCard = productCardVariant === 'Standard product card';
  if (fullBleedBackground) {
    return theme.widgets.Product?.productCardFullBleed;
  }
  if (standardProductCard) {
    return theme.widgets.Product?.productCardStandard;
  }
  return theme.widgets.Product?.productCardDetailed;
};

export const getImageURL = (props: ProductCardProps) => {
  const { productCardVariant } = props || {};
  const getDefaultImage = () => props.productImage;
  const largeProductMultiView = productCardVariant === 'Large Product Multi View';
  const shouldUseDefaultImage = () => !largeProductMultiView || !props.productImageOverride;

  if (shouldUseDefaultImage()) {
    return getDefaultImage();
  }
  return getOverrideImage(props);
};
